/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BrandQueryExecutionOptions } from '../models/BrandQueryExecutionOptions';
import type { BrandQueryResult } from '../models/BrandQueryResult';
import type { BrandQuerySession } from '../models/BrandQuerySession';
import type { BrandQuerySettings } from '../models/BrandQuerySettings';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BrandQueriesService {
    /**
     * Gets the query result of a brand query history item.
     * @param id The brand query history id.
     * @returns BrandQueryResult Success
     * @throws ApiError
     */
    public static getBrandQueryHistoryItemResult(
        id: string,
    ): CancelablePromise<BrandQueryResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/BrandQueryHistory/{id}/result',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }
    /**
     * Executes a brand query and returns the brand lookup results.
     * @param requestBody The query parameters.
     * @returns BrandQueryResult Success
     * @throws ApiError
     */
    public static executeBrandQuery(
        requestBody?: BrandQuerySession,
    ): CancelablePromise<BrandQueryResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/BrandQueries',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Client Error`,
            },
        });
    }
    /**
     * Executes a stored brand query by id and returns the brand lookup results.
     * @param id The monitoring id.
     * @param requestBody Execution options.
     * @returns BrandQueryResult Success
     * @throws ApiError
     */
    public static executeBrandQueryById(
        id: string,
        requestBody?: BrandQueryExecutionOptions,
    ): CancelablePromise<BrandQueryResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/BrandQueries/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }
    /**
     * Updates the brand query settings.
     * @param id The brand query id.
     * @param requestBody The updated brand query settings.
     * @returns BrandQuerySettings Success
     * @throws ApiError
     */
    public static updateBrandQuerySettings(
        id: string,
        requestBody?: BrandQuerySettings,
    ): CancelablePromise<BrandQuerySettings> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/BrandQueries/{id}/settings',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                422: `Client Error`,
            },
        });
    }
}
